import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-l-note",
  "use": "icon-l-note-usage",
  "viewBox": "0 0 165 165",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165 165\" id=\"icon-l-note\"><path d=\"M122 111V33H44v100h56v-20a2 2 0 0 1 2-2zm-.828 2H102v19.172zM44 31h78a2 2 0 0 1 2 2v79.172a2 2 0 0 1-.586 1.414l-20.828 20.828a2 2 0 0 1-1.414.586H44a2 2 0 0 1-2-2V33a2 2 0 0 1 2-2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol